export const ParseDecimal = (value) => parseFloat(parseFloat(value).toFixed(2));